import { ContentLayout, Container, Header } from '@cloudscape-design/components';

const NotificationsPage = () => {
  return (
    <ContentLayout header={<Header variant="h3">Notifications</Header>}>
      <Container>Notifications functionality coming soon.</Container>
    </ContentLayout>
  );
};

export default NotificationsPage;
